<template>
    <div class="chart-02">
        <v-line-chart :chart-data="datacollection" :options="options">

        </v-line-chart>
    </div>
</template>

<script>
import LineChart from '../../../charts/LineChart'

export default {
    components: {
        LineChart,
    },
    props: [
        'data',
    ],
    data() { return {
        datacollection: null,
        options: null,
    }},
    mounted() {
        this.fillData();
    },
    methods: {
        fillData() {
            this.datacollection = {
                labels: ['Domingo', 'Lunes', 'Martes', 'Miércoles'],
                datasets: [
                    { 
                        data: [1,6,1,4],
                        //label: "Tickets",
                        borderColor: "#28a744",
                        fill: false,
                        
                    },
                ],
            }
        
            this.options = {
                legend: {
                    display: false,
                },
            }
        }
    }
}
</script>